import React from 'react';
import useTableRowHintStore from '@store/table-store/table-row-hint.store.ts';
import { DynamicTableRowProps } from '@models/dynamic-table-row.model.ts';
import {
  clearTextSelection,
  DEFAULT_TABLE_KEY,
  isRowDoubleClickTarget
} from '@utils/table-row.utils.ts';

export const useRowDoubleClick = ({
  row,
  tableKey = DEFAULT_TABLE_KEY,
  onRowDoubleClick
}: Pick<DynamicTableRowProps, 'row' | 'tableKey' | 'onRowDoubleClick'>) => {
  const isLearned = useTableRowHintStore(
    (state) => !!state.learnedTables[tableKey]
  );
  const markLearned = useTableRowHintStore((state) => state.markLearned);
  const isClickable = !!onRowDoubleClick;

  const handleDoubleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
    if (
      !onRowDoubleClick ||
      !isRowDoubleClickTarget(event.currentTarget, event.target)
    ) {
      return;
    }

    clearTextSelection();
    markLearned(tableKey);
    onRowDoubleClick(row);
  };

  return {
    isClickable,
    showHint: isClickable && !isLearned,
    handleDoubleClick
  };
};
